// https://fkhadra.github.io/react-toastify/
import { Slide, toast as toastFn, ToastContainer as ToastContainerOriginal } from "react-toastify";

export const toast = (message, options = {}) => toastFn(message, options);

["success", "error", "warning", "info"].forEach((type) => {
    const defaultOptions = {};
    
    if (type === "error") {
        defaultOptions.autoClose = false;
    }
    
    toast[type] = (message, options = {}) => toastFn[type](message, {
        ...defaultOptions,
        ...options
    });
});

toast.dismiss = toastFn.dismiss;

const CloseToast = ({ closeToast }) => (
    <span className="toast-close-button" onClick={closeToast}>
        <i className="fal fa-times" />
    </span>
);

export const ToastContainer = () => (
    <ToastContainerOriginal
        position="top-center"
        transition={Slide}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
        closeButton={<CloseToast />}
    />
);
